/* Anonymous per-tab visits. No page paths, form values or cart contents are collected. */
(() => {
  'use strict';
  const endpoint = document.currentScript?.dataset.endpoint;
  if (!endpoint || window.__sunglensSessionDuration) return;
  try { if (new URL(endpoint).protocol !== 'https:') return; } catch { return; }
  window.__sunglensSessionDuration = true;
  const key = 'sunglens_site_visit_v1', expiry = 1800000;
  let state, last = performance.now(), activity = last, visible = document.visibilityState === 'visible';
  let cart = false, dirty = false;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.();
  const excluded = () => /\/(account|checkouts?|challenge)(\/|$)/i.test(location.pathname);
  const inCart = () => !!document.querySelector('cart-drawer-component dialog[open]') || /\/(?:[a-z]{2}(?:-[a-z]{2})\/)?cart\/?$/i.test(location.pathname);
  function save() { try { sessionStorage.setItem(key, JSON.stringify(state)); } catch {} }
  function start() {
    try {
      state = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (!state || Date.now() - state.last_activity > expiry) {
        let visitor = localStorage.getItem('sunglens_analytics_visitor_id');
        if (!/^[0-9a-f-]{36}$/i.test(visitor || '')) { visitor = crypto.randomUUID(); localStorage.setItem('sunglens_analytics_visitor_id', visitor); }
        const params = new URLSearchParams(location.search);
        state = {visit_id:crypto.randomUUID(),visitor_id:visitor,started_at:new Date(Math.floor(Date.now()/1000)*1000).toISOString(),active_ms:0,cart_ms:0,add_count:0,source:(params.get('utm_source') || 'direct').slice(0,128),campaign:(params.get('utm_campaign') || '').slice(0,255) || null,last_activity:Date.now()};
      }
      save(); dirty = true;
    } catch { state = null; }
  }
  function tick() {
    const now = performance.now(), nextVisible = document.visibilityState === 'visible';
    if (allowed() !== true || excluded()) {
      if (allowed() === false) { try { sessionStorage.removeItem(key); } catch {} }
      state = null; dirty = false; last = now; visible = nextVisible; cart = inCart(); return;
    }
    if (!state) { start(); last = now; }
    if (state && visible) {
      const ms = Math.round(Math.max(0, Math.min(now, activity + 60000) - last));
      state.active_ms += ms; if (cart) state.cart_ms += ms;
      dirty ||= ms > 0; save();
    }
    last = now; visible = nextVisible; cart = inCart();
  }
  function flush() {
    if (!state || !dirty || allowed() !== true || excluded()) return;
    const {last_activity, ...event} = state;
    const body = new URLSearchParams({event:JSON.stringify(event)});
    let sent = false; try { sent = navigator.sendBeacon?.(endpoint, body); } catch {}
    if (!sent) fetch(endpoint,{method:'POST',body,credentials:'omit',keepalive:true}).catch(()=>{});
    dirty = false;
  }
  function interact() {
    tick();
    if (state && Date.now() - state.last_activity > expiry) { flush(); state = null; try { sessionStorage.removeItem(key); } catch {} }
    activity = performance.now();
    if (allowed() === true && !excluded()) { if (!state) start(); if(state){ state.last_activity=Date.now();save(); } }
  }
  for (const event of ['pointerdown','keydown','scroll']) document.addEventListener(event,interact,{passive:true});
  const seen = new WeakSet();
  document.addEventListener('cart:update', event => {
    const data = event.detail?.data;
    if (seen.has(event) || data?.source !== 'product-form-component' || data.didError || allowed() !== true || excluded()) return;
    seen.add(event); interact(); if(state){state.add_count++;dirty=true;save();flush();}
  });
  document.addEventListener('visibilitychange',()=>{tick();flush();});
  document.addEventListener('visitorConsentCollected',()=>{tick();});
  window.addEventListener('pagehide',()=>{tick();flush();state=null;});
  window.addEventListener('pageshow',()=>{last=activity=performance.now();tick();});
  new MutationObserver(()=>{const before=cart;tick();if(before&&!cart)flush();}).observe(document.documentElement,{subtree:true,attributes:true,attributeFilter:['open']});
  setInterval(tick,1000);setInterval(flush,15000);
  window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)tick();});
  tick();
})();
